import React, { Component } from 'react';
import { Route, Switch, HashRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { PrivateRoute } from './Components/PrivateRoute/PrivateRoute';
import { Dashboard } from './Components/Dashboard';
import { Login } from './Components/Login';
import { InviteUser } from './Components/InviteUser';
import { StripeConnect } from './Components/StripeConnect';
import { alertActions } from './_actions';
import { ForgetPassword } from './Components/ForgetPassword';
import { ChangePassword } from './Components/ChangePassword';
import { NotFound } from './Components/NotFound';
import { Users, UsersProfile, UserOrders } from './Components/Users';
import { UserReport, Revenue } from './Components/Report';
import { Coupon } from './Components/Coupon';
import TaxSetting from './Components/TaxSettings/Tax';
import Discounts from './Components/Discount/Discount';
import { Shopkeeper, AddShopkeeper, EditShopkeeper, ViewShopkeeper } from './Components/Shopkeeper';
import Categories from './Components/Category/Categories';
import { PromoCode } from './Components/PromoCode';
import Products from './Components/ShopkeeperProduct/Products';
import { ShopList, ViewShopProducts, ProductsDetail } from './Components/Products';
import Tags from './Components/Tags/Tags';
import Trending from './Components/Trending/Trending';
import { Settings, GeneralSettings, Legal } from './Components/Settings';
import { Outlets } from './Components/Outlets';
import { Orders, CurrentOrders, OrderDetails } from './Components/Orders';
import { Earnings, ShopEarnings } from './Components/Earnings';
import { PaymentTypes } from './Components/PaymentTypes/PaymentTypes';
import { Notifications, PushNotifications, UserNotifications, EmailNotifications } from './Components/Notifications';
import { PredefinedMessages, PredefinedMessageDetails } from './Components/PredefinedMessages';
import Banners from './Components/Banners/Banners';
import { AccountActivation } from './Components/AccountActivation';
import Ideas from './Components/Idea/ideas';
import Contests from './Components/Contest/contests';
import { Logout } from './Components/Login/Logout';
import School from './Components/School/School';
import Participant from './Components/Participant/Participant';

class App extends Component {

    constructor(props) {
        super(props);

        const { dispatch } = this.props;
    }
    render() {
        const { alert, authentication } = this.props;
        let userData = '';
        if (authentication.user !== undefined) {
            if (authentication.user.role_type !== undefined) { userData = authentication.user }
            else { userData = JSON.parse(authentication.user); }
        }


        // console.log("userData-----",userData);

        return (
            <div>
                {alert.message &&
                    <div className={`alert ${alert.type}`}>{alert.message}</div>
                }
                <HashRouter>
                    <div>

                        {/* <PrivateRoute exact path="/tables" component={Tables} />
                        <PrivateRoute exact path="/users" component={Users} />
                        <PrivateRoute exact path="/profile" component={UsersProfile} /> */}
                        <Switch>
                            <Route exact path="/" component={Login} />
                            <Route path="/login" component={Login} />
                            <Route path="/invite-user" component={InviteUser} />
                            <Route path="/stripe-connect" component={StripeConnect} />
                            {/* <Route path="/logout" component={Logout} /> */}

                            <Route exact path="/forget-password" component={ForgetPassword} />
                            <Route exact path="/account-activate/:securitycode" component={AccountActivation} />
                            <PrivateRoute exact path="/change-password" component={ChangePassword} />
                            <PrivateRoute path="/dashboard" component={Dashboard} />
                            <PrivateRoute exact path="/profile" component={UsersProfile} />
                            <PrivateRoute exact path="/coupon" component={Coupon} />
                            {
                                userData !== undefined &&
                                    userData !== null &&
                                    userData.role_type !== undefined &&
                                    userData.role_type.length > 0 &&
                                    userData.role_type[0] === 'admin' ?
                                    <React.Fragment>
                                        <PrivateRoute exact path="/users" component={Users} />
                                        <PrivateRoute exact path="/user-orders/:id" component={UserOrders} />
                                        <PrivateRoute exact path="/shopkeeper" component={Shopkeeper} />
                                        <PrivateRoute exact path="/orders" component={Orders} />
                                        <PrivateRoute exact path="/order-details/:id" component={OrderDetails} />
                                        <PrivateRoute exact path="/add-shopkeeper" component={AddShopkeeper} />
                                        <PrivateRoute path="/edit-shopkeeper/:id" component={EditShopkeeper} />
                                        <PrivateRoute path="/view-shopkeeper/:id" component={ViewShopkeeper} />
                                        <PrivateRoute exact path="/shop-list" component={ShopList} />
                                        <PrivateRoute exact path="/shop/:shopname/:id" component={ViewShopProducts} />
                                        <PrivateRoute exact path="/product-details/:id" component={ProductsDetail} />
                                        <PrivateRoute exact path="/categories" component={Categories} />
                                        <PrivateRoute exact path="/ideas" component={Ideas} />
                                        <PrivateRoute exact path="/contests" component={Contests} />
                                        <PrivateRoute exact path="/tax-setting" component={TaxSetting} />
                                        <PrivateRoute exact path="/tags" component={Tags} />
                                        <PrivateRoute exact path="/trending" component={Trending} />
                                        <PrivateRoute exact path="/settings" component={Settings} />
                                        <PrivateRoute exact path="/general-settings" component={GeneralSettings} />
                                        <PrivateRoute exact path="/payment-types" component={PaymentTypes} />
                                        <PrivateRoute exact path="/notifications" component={Notifications} />
                                        <PrivateRoute exact path="/push-notifications" component={PushNotifications} />
                                        <PrivateRoute exact path="/email-notifications" component={EmailNotifications} />
                                        <PrivateRoute exact path="/predefined-messages" component={PredefinedMessages} />
                                        <PrivateRoute exact path="/predefined-messages-details/:id" component={PredefinedMessageDetails} />
                                        <PrivateRoute exact path="/legal" component={Legal} />
                                        <PrivateRoute exact path="/banners" component={Banners} />
                                        <PrivateRoute exact path="/earnings" component={Earnings} />
                                        <PrivateRoute exact path="/shop-earnings/:id/:earningType" component={ShopEarnings} />
                                        <PrivateRoute exact path="/outlets" component={Outlets} />
                                        <PrivateRoute exact path="/school" component={School} />
                                        <PrivateRoute exact path="/participant" component={Participant} />





                                        {/* <PrivateRoute exact path="/reports" component={UserReport} />
                                        <PrivateRoute exact path="/revenue" component={Revenue} />*/}

                                    </React.Fragment>
                                    : ''
                            }

                            {
                                userData !== undefined &&
                                    userData !== null &&
                                    userData.role_type !== undefined &&
                                    userData.role_type.length > 0 &&
                                    userData.role_type[0] === 'shopkeeper' ?
                                    <React.Fragment>
                                        <PrivateRoute exact path="/shopkeeper-products" component={Products} />
                                        <PrivateRoute exact path="/shop-discounts" component={Discounts} />
                                        <PrivateRoute exact path="/user-notifications" component={UserNotifications} />
                                        <PrivateRoute exact path="/orders" component={Orders} />
                                        <PrivateRoute exact path="/order-details/:id" component={OrderDetails} />
                                        <PrivateRoute exact path="/current-orders" component={CurrentOrders} />
                                        <PrivateRoute exact path="/coupon" component={Coupon} />
                                        <PrivateRoute exact path="/shop-earnings/:id/:earningType" component={ShopEarnings} />
                                    </React.Fragment>
                                    : ''
                            }



                            <Route path="*" exact={true} component={NotFound} />
                        </Switch>
                    </div>
                </HashRouter>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { alert, authentication } = state;
    return {
        alert, authentication
    };
}

const connectedApp = connect(mapStateToProps)(App);
export { connectedApp as App };
